import { isFeatureEnabled } from 'owa-feature-flags';
import getRoamingTimezonesCloudSetting from '../selectors/getRoamingTimezonesCloudSetting';
import TimezoneInfo from '../store/schema/TimezoneInfo';

const DEFAULT_ROAMING_TIMEZONES_FALLBACK = [];

/**
 * Gets the default value for the roaming timezones setting
 */
export default function getDefaultRoamingTimezones(): TimezoneInfo[] {
    if (!isFeatureEnabled('mon-multipleTimezones')) {
        return DEFAULT_ROAMING_TIMEZONES_FALLBACK;
    }

    const roamingTimezones = getRoamingTimezonesCloudSetting();

    return roamingTimezones != null ? roamingTimezones : DEFAULT_ROAMING_TIMEZONES_FALLBACK;
}
